(function() {
  console.log('>> test12-dcart');
  window.addEventListener("DCART:config.initialized", function (e) {
    console.log('>> DCART:config.initialized');
    DCART.discountbox.placement = {
      cartDiscountSelector: {
        path: ".dcart-cart-drawer",
        type: 0,
      },
      ajaxDicountSelector: {
        path: ".dcart-cart-drawer",
        type: 0,
      },
      cartTotalSelector: {
        path: ".dcart-cart-drawer-price",
        type: 0,
      },
      ajaxTotalSelector: {
        path: ".dcart-cart-drawer-price",
        type: 0,
      },
    };
  });
})();